import { gridSize as getGridSize } from '@atlaskit/theme/constants';

export const gridSize = getGridSize();

export const BLUR = 'blur' as const;
export const ENTER = 'enter' as const;

export const MAX_SUMMARY_LENGTH = 255 as const;
